import { useCallback } from 'react';
import { useIframeMessageContext } from '../../IframeMessageContext';
import { registerIframeMessageHook } from './IframeRegistration';
const MESSAGE_TYPE = 'site-components';
export function useSendSiteComponents() {
    const { postMessage } = useIframeMessageContext();
    const sendSiteComponents = useCallback((siteComponents) => {
        postMessage(MESSAGE_TYPE, siteComponents);
    }, [postMessage]);
    return { sendSiteComponents };
}
const handleMessage = (context, message) => {
    const { setSiteComponents } = context;
    if (message.body) {
        // console.log('received site components', message.body);
        setSiteComponents(message.body);
    }
};
registerIframeMessageHook(MESSAGE_TYPE, useSendSiteComponents, handleMessage);
//# sourceMappingURL=useSendSiteComponents.js.map